import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicy: React.FC = () => {
  return (
    <div className="w-full bg-white">
      <section className="py-16">
        <div className="layout-container max-w-[800px] mx-auto px-5">
          <nav className="mb-6 text-[12px] font-description text-[#919191]">
            <Link to="/" className="hover:text-[#212121] transition-colors">
              Homepage
            </Link>
            <span className="mx-2">/</span>
            <span className="text-[#212121]">Cookie Policy</span>
          </nav>

          <h1 className="font-title text-[36px] md:text-[46px] font-semibold leading-[1.1] text-[#212121]">
            Cookie Policy
          </h1>
          
          <div className="mt-8 space-y-6 font-description text-[14px] font-light leading-[1.6] text-[#919191]">
            <p><strong>Effective Date:</strong> August 5, {new Date().getFullYear()}</p>
            <p><strong>Company:</strong> Bao Technologies (Bao Technologies and Travels SARL)</p>

            <h2 className="font-title text-[20px] font-medium text-[#212121] mt-10 mb-4">What Are Cookies</h2>
            <p>
              Cookies are small text files stored on your device when you visit a website. They help the site function properly, provide security, and understand how visitors interact with the content.
            </p>

            <h2 className="font-title text-[20px] font-medium text-[#212121] mt-10 mb-4">How We Use Cookies</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Essential Cookies:</strong> Required for basic website functionality, navigation, and security.</li>
              <li><strong>Analytics &amp; Performance Cookies:</strong> Help us understand visitor interactions, traffic sources, and site performance to improve user experience.</li>
            </ul>

            <h2 className="font-title text-[20px] font-medium text-[#212121] mt-10 mb-4">Managing Cookies</h2>
            <p>
              Most web browsers allow you to control cookies through their settings preferences. Disabling certain cookies may impact the functionality of parts of the website.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicy;
